import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { validationResponseSchema } from "../validation-schemas";

export const setShippingMethodOrder = {
  name: "setShippingMethodOrder" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    orderedShippingMethodIds: z.array(zExt.objectId()),
    skipValidation: z.boolean().optional(),
  }),
  output: validationResponseSchema,
};
